export default "__VITE_ASSET__CcjxaK5p__"